import React from 'react';
import {
    Box,
    Grid,
    TextField,
    Slider,
    Button,
    Typography,
    CircularProgress,
} from '@mui/material';
import SingleDatePicker from './SingleDatePicker';

const AlertFilterPanel = ({
    alertFilters,
    setAlertFilters,
    onApplyFilters,
    isLoading
}) => {
    return (
        <Box sx={{ borderRadius: 2, display: 'flex', justifyContent: 'space-between', px: { xs: 1.5, sm: 2 }, pb: { xs: 0.5, sm: 1.25 }, fontSize: { xs: '0.9rem', sm: '1rem', md: '1rem', lg: '1rem', xl: '1.1rem' } }}>
            <Grid container spacing={{ xs: 1, sm: 3, md: 1, lg: 4, xl: 6 }} alignItems="center">
                {/* <Grid item xs={12} md={12} lg={4} xl={4} sx={{ width: { xs: 200, sm: 200, md: 200, lg: 200, xl: 380 } }} >
                    <TextField
                        fullWidth
                        size="medium"
                        label="Query"
                        placeholder="Enter your query ..."
                        value={(alertFilters.query || '')}
                        onChange={(e) => setAlertFilters(prev => ({ ...prev, query: e.target.value }))}
                    />
                </Grid> */}

                <Grid item xs={12} sm={6} md={6} lg={4} xl={4} sx={{ width: { xs: 200, sm: 200, md: 300, lg: 300, xl: 400 } }} >
                    <SingleDatePicker
                        value={alertFilters.reference_date}
                        onChange={(val) => {
                            if (val) {
                                setAlertFilters(prev => ({ ...prev, reference_date: val }));
                            }
                        }}
                    />
                </Grid>

                {/* <Grid item xs={12} md={4} lg={2} sx={{ mt: { xs: 0.5, md: 0 } }}>
                    <Typography gutterBottom sx={{ mb: { xs: 0.5, md: 1 } }}>Threshold</Typography>
                    <Slider
                        value={alertFilters.thresold}
                        onChange={(_, value) => setAlertFilters(prev => ({ ...prev, thresold: value }))}
                        valueLabelDisplay="auto"
                        sx={{
                            color: 'rgba(94, 79, 170, 1)',
                            '& .MuiSlider-thumb': {
                                backgroundColor: 'rgba(94, 79, 170, 1)',
                            },
                            '& .MuiSlider-track': {
                                backgroundColor: 'rgba(94, 79, 170, 1)',
                            },
                            '& .MuiSlider-rail': {
                                backgroundColor: '#d8d8d8',
                            }
                        }}
                        step={0.1}
                        marks={[
                            { value: 1, label: 'Low' },
                            { value: 2, label: 'High' },
                        ]}
                        min={1}
                        max={2}
                    />
                </Grid> */}

                <Grid item xs={12} sm={6} md={12} lg={2} xl={2} sx={{ display: 'flex', justifyContent: { xs: 'stretch', md: 'flex-start' }, mb: 1 }}>
                    <Button
                        variant="contained"
                        onClick={onApplyFilters}
                        disabled={isLoading}
                        startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : null}
                        sx={{
                            width: { xs: '100%', md: 'auto' }, height: { xs: 32, md: 34, lg: 40, xl: 46 }, backgroundColor: 'rgba(94, 79, 170, 1)', color: '#fff', borderRadius: 1,
                            '&:hover': {
                                backgroundColor: '#9B86FF',
                                cursor: 'pointer'
                            }
                        }}
                    >
                        {isLoading ? 'Loading...' : 'Apply Filters'}
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default AlertFilterPanel;
